<template>
    <div v-if="canBeDeleted">
        <b-link
            v-if="!isLost"
            href="#"
            title="Déplacer dans les prospects perdus"
            @click="looseProspect()"
        >
            <i class="fas fa-fw fa-thumbs-down text-primary"></i>
        </b-link>
        <b-link
            v-else
            href="#"
            title="Déplacer dans les prospects actifs"
            @click="activateProspect()"
        >
            <i class="fas fa-fw fa-thumbs-up text-primary"></i>
        </b-link>
    </div>
</template>

<script>
export default {
    name: 'DeleteProspectHandler',

    props: {
        id: 0,
        isLost: null,
        canBeDeleted: false,
    },

    methods: {
        async looseProspect() {
            try {
                await axios.delete(`/clients/${this.id}`)
                this.$emit('status-has-changed')
            } catch (error) {
                console.log(error)
            }
        },
        async activateProspect() {
            try {
                await axios.put(`/clients/${this.id}`)
                this.$emit('status-has-changed')
            } catch (error) {
                console.log(error)
            }
        },
    },
}
</script>

<style scoped></style>
